export const ACH_MANUAL_BATCH_CONTAINER_TAG_NAME = 'ach-manual-batch-container';
